;(function($){

  window.roomsForm = {

    description: "",

    init: function(options) {
      this.options = options;
      this.bindEvents(options.context);
      this.updateDescription(this.options.onCloseForm, true);
    },

    createForm: function(number) {
      var $form;
      $form = $('.js-room-form').last().clone();
      $form.attr('data-room-id', (number -1));
      $form.find('.js-kids-age-wrapper').html('');
      $form.find('.js-room-form-number').text(number);
      $form.find('.js-adults-select').attr('name', 'rooms[' + (number - 1) + '][adults]');
      $form.find('.js-kids-select').attr('name', 'rooms[' + (number - 1) + '][kids]');
      return $form;
    },

    createAgeSelector: function(number, parentId) {
      var html = '<li><label>Edad niño ' + number + '</label><select class="js-kids-age" name="rooms['+parentId+'][ages][]">';
      for (var i = 0; i <= 17; i++) {
        html += '<option value="' + i + '">'+ i +' años</option>';
      }
      html += '</select></li>';

      return html;
    },

    updateDescription: function(callback, firstTime) {
      var adults = 0, kids = 0 , description, age, data = [],
          ages = [];
      var rooms = $('.js-room-form');

      for (var i = 0; i < rooms.length; i++) {
        adults += parseInt($('.js-adults-select', rooms[i]).val());
        kids += parseInt($('.js-kids-select', rooms[i]).val());
      }

      description = adults + (adults > 1 ? " adultos":" adulto");
      if (kids > 0) description += " y " + kids + (kids > 1 ? " niños":" niño");
      description += ", " + rooms.length +  " hab. / apar.";

      callback(description, firstTime);
    },

    getDescription: function() { return this.description; },

    bindEvents: function(context) {
      var self = this;
      context = context || document;

      $('.js-rooms-select', context).on('change', function() {
        var num = $(this).val();
        var current = $('.js-room-form').length;
        if (num > current) {
          for(var i = current; i < num;  i++) {
            $form = self.createForm(i+1);
            $('.js-rooms-list').append($form);
            self.bindEvents($form);
          }
        } else {
          $('.js-room-form:gt(' + (num - 1) + ')').remove();
        }
      })

      $('.js-kids-select', context).on('change', function() {
        var parent = $(this).closest('.js-room-form');
        parentId = parent.data('room-id');
        $('.js-kids-age-wrapper', parent).html('');
        for (var i = 1; i <= $(this).val(); i++) {
          $('.js-kids-age-wrapper', parent).append(self.createAgeSelector(i, parentId));
        }
      });

      $('.js-close-modal', context).on('click', function() {
        self.updateDescription(self.options.onCloseForm);
        context.foundation('reveal','close');
      })

    },

    getData: function() {
      var data = [],
          rooms = $('.js-room-form'),
          room;

      for (var i = 0; i < rooms.length; i++) {
        room = {
          adults : parseInt($('.js-adults-select', rooms[i]).val()),
          kids   : parseInt($('.js-kids-select', rooms[i]).val()),
          ages   : []
        };

        $('.js-kids-age', rooms[i]).each(function() {
          room.ages.push($(this).val());
        });

        data.push(room);

      }

      return data;
    }
  }

})(jQuery);
